import React from "react";
import useReveal from "../hooks/useReveal";
import PageHero from "../components/PageHero";
import Pricing from "../components/Pricing";

export default function PricingPage() {
  useReveal();
  return (
    <>
      <PageHero eyebrow="Price List" title="Services & Pricing" subtitle="Every service and sub-service, with transparent pricing - straight from our studio menu." />
      <Pricing />
    </>
  );
}
